import { Label, RadioButton } from '@nokia-csf-uxr/ccfk';
import FieldSet, { FieldSetContent, Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import { RadioButtonLabelContent } from '@nokia-csf-uxr/ccfk/RadioButton';
import React from 'react';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import Dropbox from '../../Dropbox';
import HelpIcon from '../../HelpIcon';
import ValueInput from '../../ValueInput';
import Form from 'react-bootstrap/esm/Form';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * RainOutagePred component to select ITU.R P530 or Crane
 */
export default class RainOutagePred extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);
    }

    /**
     * Function is called when the rain outage norm is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeNorm(link:Readonly<any>, newData: {}) {
        link.define("rainOutageNorm", newData)
    }

    /**
     * Function is called when the rain rate norm is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeRainRateNorm(link:Readonly<any>, newData: {}) {
        link.define("rainRateNorm", newData)
    }

    /**
     * Function is called when the rain rate is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeRainRate(link:Readonly<any>, newData: {}) {
        link.define("rainRate", newData)
    }

    /**
     * Function is called when the crane zone is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeCraneZone(link:Readonly<any>, newData: {}) {
        link.define("craneZone", newData)
    }

    /**
     * If the rain rate which is chosen in advanced link is not in the dropbox then this one is added
     */
    rainRateSwitch(rainRate:number, rainRateP530: [{id: number, val:number}]) {
        if(rainRate == null) return rainRateP530;
        for (let i = 0; i < rainRateP530.length; i++) {
            if(rainRateP530[i].val == rainRate) return rainRateP530;

            if(rainRateP530[i].val > rainRate) {
                rainRateP530.splice(i, 0, {id: 0, val: rainRate});
                return rainRateP530;
            }            
        }
    }

    render() {
        return (
        <Container>
            {this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                    <SingleBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                { link.prop_accuracy != "advanced" ? 
                                <>
                                <Row>
                                    <Form.Label>Rain outage standard</Form.Label>
                                    <FieldSetContent role="radiogroup" className="justify-content-center mb-3 standard-FieldSetContent center-radiobnt">
                                        { linkRef?.rainOutagePred?.map((rainOutagePred: {idRainOutPred: number, label: string}, index: any) =>
                                            <Form.Check
                                                inline
                                                label={ rainOutagePred.label }
                                                type="radio"
                                                checked={link?.rainOutageNorm?.idRainOutPred === rainOutagePred.idRainOutPred}
                                                onChange={() => this.onChangeNorm(link, {index: index, ...rainOutagePred}) }
                                            />
                                        ) }
                                    </FieldSetContent>
                                </Row>

                                <Row>
                                    <div className={link?.rainOutageNorm?.idRainOutPred != 1 ? "hide-input" : "pe-0"}>
                                        <Form.Label>Rain rate (mm/hr)</Form.Label>
                                        <Dropbox 
                                            uniqueKey="val" 
                                            displayInputKey="val"
                                            showStartedKey={true}
                                            startedKey={link?.rainRate?.val}
                                            values={(linkRef.rainRateP530 != null) ? this.rainRateSwitch(link?.rainRate?.val, linkRef.rainRateP530) : []} 
                                            onChange={(newData) => this.onChangeRainRate(link, newData)}
                                        />
                                    </div>
                                    <div className={link?.rainOutageNorm?.idRainOutPred != 2 ? "hide-input" : "pe-0"}>
                                        <Form.Label>Crane zone <HelpIcon text="Crane zone map" url="/assets/utils/CraneZone.jpg"/></Form.Label>
                                        <Dropbox 
                                            uniqueKey="idCraneZone" 
                                            displayInputKey="label" 
                                            showStartedKey={true}
                                            startedKey={link?.craneZone?.idCraneZone}
                                            values={(linkRef.craneZones != null) ? linkRef.craneZones : []} 
                                            onChange={(newData) => this.onChangeCraneZone(link, newData)}
                                        />
                                    </div>
                                </Row>
                            </> : 
                            <>
                                <Row className='mb-2'>
                                    <Col xs={link?.rainOutageNorm?.idRainOutPred != 2 ? 12 : 7}>
                                        <Form.Label>Rain outage standard</Form.Label>
                                        <FieldSetContent role="radiogroup" className="justify-content-center standard-FieldSetContent center-radiobnt">
                                            { linkRef?.rainOutagePred?.map((rainOutagePred: {idRainOutPred: number, label: string}, index: any) =>
                                                <Form.Check
                                                    inline
                                                    label={ rainOutagePred.label }
                                                    type="radio"
                                                    checked={link?.rainOutageNorm?.idRainOutPred === rainOutagePred.idRainOutPred}
                                                    onChange={(e) => this.onChangeNorm(link, {index: index, ...rainOutagePred}) }
                                                />
                                            ) }
                                        </FieldSetContent>
                                    </Col>

                                    <Col xs={link?.rainOutageNorm?.idRainOutPred != 2 ? 0 : 5}>

                                        <div className={link?.rainOutageNorm?.idRainOutPred != 2 ? "hide-input" : ""}>
                                            <Form.Label>Crane zone <HelpIcon text="Crane zone map" url="/assets/utils/CraneZone.jpg"/></Form.Label>
                                            <Dropbox 
                                                uniqueKey="idCraneZone" 
                                                displayInputKey="label" 
                                                showStartedKey={true}
                                                startedKey={link?.craneZone?.idCraneZone}
                                                values={(linkRef.craneZones != null) ? linkRef.craneZones : []} 
                                                onChange={(newData) => this.onChangeCraneZone(link, newData)}
                                            />
                                        </div>
                                    </Col>
                                    
                                </Row>

                                {link?.rainOutageNorm?.idRainOutPred != 1 ? <></> :
                                <>
                                <Row>
                                    <Col xs={4}>
                                        <Form.Label>Rain rate (mm/hr)</Form.Label>
                                        <ValueInput valueType="integer" value={link?.rainRate?.val ? link?.rainRate?.val : 0}
                                            onChange={(data: any) => {
                                                let result = {
                                                    val : parseInt(data)
                                                }
                                                link.define("rainRate", result)                              
                                            }}  
                                            onBlur={(data: any, error: any) => {
                                                if(data <= 0) {
                                                    error(true);
                                                }
                                            }}></ValueInput>
                                    </Col>
                                    <Col xs={8}>
                                        <Form.Label>Rain rate standard <HelpIcon text="Rain rate standard comparison" url="/assets/utils/RainRate_ITURP8357.jpg"/></Form.Label>
                                        <FieldSetContent role="radiogroup" className="standard-FieldSetContent center-radiobnt">
                                            { linkRef?.rainRateNorm?.map((rainRateNorm: {idRainRateNorm: number, name: string}, index: any) =>
                                                <Form.Check
                                                    inline
                                                    label={ rainRateNorm.name }
                                                    type="radio"
                                                    checked={link?.rainRateNorm?.idRainRateNorm === rainRateNorm.idRainRateNorm}
                                                    onChange={() => this.onChangeRainRateNorm(link, {index: index, ...rainRateNorm}) }
                                                />
                                            ) }
                                        </FieldSetContent>
                                    </Col>
                                </Row>
                                </> }
                            </> 
                            }
                            </>
                        )}
                    </SingleBandLinkReferenceContext.Consumer>
                    </>
                    )}
                </SingleBandLinkUserContext.Consumer>
            :
                <DualBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                    <DualBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                { link.prop_accuracy != "advanced" ? 
                                <>
                                <Row>
                                    <Form.Label>Rain outage standard</Form.Label>
                                    <FieldSetContent role="radiogroup" className="justify-content-center mb-3 standard-FieldSetContent center-radiobnt">
                                        { linkRef?.rainOutagePred?.map((rainOutagePred: {idRainOutPred: number, label: string}, index: any) =>
                                            <Form.Check
                                                inline
                                                label={ rainOutagePred.label }
                                                type="radio"
                                                checked={link?.rainOutageNorm?.idRainOutPred === rainOutagePred.idRainOutPred}
                                                onChange={() => this.onChangeNorm(link, {index: index, ...rainOutagePred}) }
                                            />
                                        ) }
                                    </FieldSetContent>
                                </Row>

                                <Row>
                                    <div className={link?.rainOutageNorm?.idRainOutPred != 1 ? "hide-input" : ""}>
                                        <Form.Label>Rain rate (mm/hr)</Form.Label>
                                        <Dropbox 
                                            uniqueKey="val" 
                                            displayInputKey="val"
                                            showStartedKey={true}
                                            startedKey={link?.rainRate?.val}
                                            values={(linkRef.rainRateP530 != null) ? this.rainRateSwitch(link?.rainRate?.val, linkRef.rainRateP530) : []} 
                                            onChange={(newData) => this.onChangeRainRate(link, newData)}
                                        />
                                    </div>
                                    <div className={link?.rainOutageNorm?.idRainOutPred != 2 ? "hide-input" : ""}>
                                        <Form.Label>Crane zone <HelpIcon text="Crane zone map" url="/assets/utils/CraneZone.jpg"/></Form.Label>
                                        <Dropbox 
                                            uniqueKey="idCraneZone" 
                                            displayInputKey="label" 
                                            showStartedKey={true}
                                            startedKey={link?.craneZone?.idCraneZone}
                                            values={(linkRef.craneZones != null) ? linkRef.craneZones : []} 
                                            onChange={(newData) => this.onChangeCraneZone(link, newData)}
                                        />
                                    </div>
                                </Row>
                            </> : 
                            <>
                                <Row className='mb-2'>
                                    <Col xs={link?.rainOutageNorm?.idRainOutPred != 2 ? 12 : 7}>
                                        <Form.Label>Rain outage standard</Form.Label>
                                        <FieldSetContent role="radiogroup" className="justify-content-center standard-FieldSetContent center-radiobnt">
                                            { linkRef?.rainOutagePred?.map((rainOutagePred: {idRainOutPred: number, label: string}, index: any) =>
                                                <Form.Check
                                                    inline
                                                    label={ rainOutagePred.label }
                                                    type="radio"
                                                    checked={link?.rainOutageNorm?.idRainOutPred === rainOutagePred.idRainOutPred}
                                                    onChange={(e) => this.onChangeNorm(link, {index: index, ...rainOutagePred}) }
                                                />
                                            ) }
                                        </FieldSetContent>
                                    </Col>

                                    <Col xs={link?.rainOutageNorm?.idRainOutPred != 2 ? 0 : 5}>

                                        <div className={link?.rainOutageNorm?.idRainOutPred != 2 ? "hide-input" : ""}>
                                            <Form.Label>Crane zone <HelpIcon text="Crane zone map" url="/assets/utils/CraneZone.jpg"/></Form.Label>
                                            <Dropbox 
                                                uniqueKey="idCraneZone" 
                                                displayInputKey="label" 
                                                showStartedKey={true}
                                                startedKey={link?.craneZone?.idCraneZone}
                                                values={(linkRef.craneZones != null) ? linkRef.craneZones : []} 
                                                onChange={(newData) => this.onChangeCraneZone(link, newData)}
                                            />
                                        </div>
                                    </Col>
                                    
                                </Row>

                                {link?.rainOutageNorm?.idRainOutPred != 1 ? <></> :
                                <>
                                <Row>
                                    <Col xs={4}>
                                        <Form.Label>Rain rate (mm/hr)</Form.Label>
                                        <ValueInput valueType="integer" value={link?.rainRate?.val ? link?.rainRate?.val : 0}
                                            onChange={(data: any) => {
                                                let result = {
                                                    val : parseInt(data)
                                                }
                                                link.define("rainRate", result)                              
                                            }}  
                                            onBlur={(data: any, error: any) => {
                                                if(data <= 0) {
                                                    error(true);
                                                }
                                            }}></ValueInput>
                                    </Col>
                                    <Col xs={8}>
                                        <Form.Label>Rain rate standard <HelpIcon text="Rain rate standard comparison" url="/assets/utils/RainRate_ITURP8357.jpg"/></Form.Label>
                                        <FieldSetContent role="radiogroup" className="standard-FieldSetContent center-radiobnt">
                                            { linkRef?.rainRateNorm?.map((rainRateNorm: {idRainRateNorm: number, name: string}, index: any) =>
                                                <Form.Check
                                                    inline
                                                    label={ rainRateNorm.name }
                                                    type="radio"
                                                    checked={link?.rainRateNorm?.idRainRateNorm === rainRateNorm.idRainRateNorm}
                                                    onChange={() => this.onChangeRainRateNorm(link, {index: index, ...rainRateNorm}) }
                                                />
                                            ) }
                                        </FieldSetContent>
                                    </Col>
                                </Row>
                                </> }
                            </> 
                            }
                            </>
                        )}
                    </DualBandLinkReferenceContext.Consumer>
                    </>
                    )}
                </DualBandLinkUserContext.Consumer>
            }
        </Container>
        );
    }

}